module.exports = __webpack_public_path__ + "static/media/avatar.49295880.svg";